/**
 * Prepare a bunch of CSS classes that affect layouting for desktop.
 *
 * Their combination applies different offsets etc. to fix layout for
 * different OS + browser combinations.
 *
 * Import the function, pass it 'this' inside a global mixin and bind
 * the result to a computed shortcut to make the styles available
 * everywhere. Depends on store and runtimeEnv object inside it.
 */
export function desktopModeStylesFactory(context) {
  return {
    // Via store
    'desktop-mode': context.$store.state.common.desktopMode,
    'fullscreen-mode': context.$store.state.common.fullscreenMode,
    'visible-drawer': context.$store.state.common.showDrawer,
    // Via runtime environment
    chrome: context.$store.state.common.runtimeEnv.chrome,
    firefox: context.$store.state.common.runtimeEnv.firefox,
    linux: context.$store.state.common.runtimeEnv.linux,
    mac: context.$store.state.common.runtimeEnv.mac,
    safari: context.$store.state.common.runtimeEnv.safari,
    windows: context.$store.state.common.runtimeEnv.windows,
  };
}



// WEBPACK FOOTER //
// ./src/mixins/desktopModeStyles.js